import type { HistoryData } from '~/vendor/cxy/types';

export const getOppositionTeamName = (item: HistoryData, americanFormat = false) => {
  return americanFormat
    ? item.participant.side === 'HOME'
      ? item.awayTeam.shortName
      : `@${item.homeTeam.shortName}`
    : item.participant.side === 'HOME'
      ? `${item.awayTeam.shortName} (H)`
      : `${item.homeTeam.shortName} (A)`;
};

export const getGameDate = (item: HistoryData, americanFormat = false) => {
  const date = new Date(item.startTime);
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return americanFormat ? `${month}/${day}` : `${day}/${month}`;
};
